export default __webpack_public_path__ + "c782a9c6f75a90302415858b5e53e066.png";